export const configuredConnectorsSchema = {
    type: 'object',
    properties: {
        connectors: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    tag: { type: 'string' },
                    type: { type: 'string' },
                    configurations: {
                        type: 'object',
                        properties: {
                            baseUrl: { type: 'string' },
                            authUrl: { type: 'string' },
                            username: { type: 'string' },
                            password: { type: 'string' },
                            citycode: { type: 'string' },
                            configuredchannels: { type: 'string' },
                            normalizedLang: { type: 'string' },
                            clientId: { type: 'string' },
                            clientSecret: { type: 'string' },
                            subscriptionId: { type: 'string' },
                        },
                    },
                },
            },
        },
    },
};
